export {
  ThemeBorder,
  ThemeDensity,
  ThemeMode,
  ThemePreset,
  THEME_PRESETS,
  type ThemeConfig,
  type ThemePresetConfig,
} from "@ibada/shared-types/theme"

import { ThemeBorder, ThemeDensity, ThemeMode, ThemePreset, THEME_PRESETS, type ThemeConfig } from "@ibada/shared-types/theme"

export const DEFAULT_THEME_CONFIG: ThemeConfig = {
  version: 1,
  mode: ThemeMode.System,
  preset: ThemePreset.Emerald,
  primary: THEME_PRESETS[ThemePreset.Emerald].primary,
  accent: THEME_PRESETS[ThemePreset.Emerald].accent,
  radius: 0.4,
  density: ThemeDensity.Comfortable,
  border: ThemeBorder.Normal,
}
